module.exports = __webpack_public_path__ + "static/media/useful3.4b7824c0.png";